module.exports = __webpack_public_path__ + "static/img/check.fbf1eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check.png
// module id = mbzP
// module chunks = 1